import Environment from '../common/Environment';
import Member from '../entities/Member';
import Wiki from '../entities/Wiki';
import WikiJson from '../jsons/WikiJson';

export default class DeleteWiki {
  execute(wiki: Wiki, account: Member): Promise<void> {
    const method: string = 'DELETE';
    const path = Environment.server() + '/wiki/' + wiki.id;

    return new Promise((resolve, reject) => {
      fetch(path, {
        method,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          account
        })
      })
        .then((response: Response) => {
          if (response.ok) {
            return response.json();
          } else {
            reject(response.status);
            return null;
          }
        })
        .then((responseJson: WikiJson) => {
          if (
            responseJson.api === undefined ||
            responseJson.api.status === undefined
          ) {
            reject('Server Error');
          } else if (responseJson.api.status === 'success') {
            resolve();
          } else {
            reject(responseJson.api.errorMessage);
          }
        })
        .catch(error => {
          console.log(error.message);
          reject(
            `通信に失敗しました。ネットワークに問題がある可能性があります。\n${error.message}`
          );
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/apis/DeleteWiki.ts